<template>
    <div class="wrapper">
      <div class="content-wrapper">
        <div class="container-lg">
            <div class="row mb-12">
                <div class="col">
                    <div class="page-title-nav row">
                        <div class="col-2 col-lg-3">
                          <router-link
                                :to="`/member/home`"
                                class="btn btn-outline-secondary btn-custom btn-back">
                                <i
                                    class="fa-icon fa-regular fa-arrow-left me-0"></i><span
                                    class="d-none d-lg-block ms-2">ย้อนกลับ</span>
                            </router-link>
                        </div>
                        <div class="col-8 col-lg-6">
                            <h1 class="page-title">รายการเติม/ถอน</h1>
                        </div>
                        <div class="col-12 col-lg-3">
                            <a href="#" class="btn btn-primary btn-custom d-none"><i
                                    class="fa-icon fa-regular fa-home"></i><span>button</span></a>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-12">
                            <div class="content-card">
                                <div class="content-card-title d-flex justify-content-start flex-wrap gap-2">
                                    <button v-for="(filter, indexf) in filters" :key="indexf"
                                        :class="['btn', 'btn-filter', filter.active ? 'btn-outline-primary btn-active text-white' : 'btn-outline-secondary']"
                                        @click="setActiveFilter(indexf);getTranfer(filter.id);">
                                        <i class="fa-icon fa-solid"
                                            :class="[filter.active ? 'fa-circle-check' : 'fa-circle']"></i>{{
                                        filter.name }}
                                    </button>
                                </div>
                                <div class="content-card-body p-0  ">
                                    <div class="row text-danger" v-if="checkData(listTransaction)">
                                        <div class="col-12 text-center p-5">
                                            ไม่มีรายการ
                                        </div>
                                    </div>
                                    <template v-else>
                                        <template v-for="(item, index) in listTransaction">
                                            <div :key="index" class="tx-item">
                                              <!-- {{ item }} -->
                                                <div class="tx-datetime">
                                                    <small></small>
                                                    <small class="text-end">เมื่อ {{ item.date }} {{ item.time
                                                        }}</small>
                                                </div>
                                                <div class="tx-content">
                                                    <div class="row">
                                                        <div class=" mb-2 col-6  col-sm-3 col-md-3 col-lg-2">
                                                            <div class="d-flex justify-content-start flex-column">
                                                                <label>ประเภท</label>
                                                                <div class="info">
                                                                    <span :class="getclassStagement(item.stagement)"
                                                                        class="badge ">{{ item.stagement }}</span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="col">
                                                            <div class="d-flex justify-content-start flex-column">
                                                                <label>ธนาคาร</label>
                                                                <div class="info">
                                                                    <strong>{{ item.bankName }}</strong>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class=" mb-2 col-6  col-sm-3 col-md-3 col-lg-2 ">
                                                            <div
                                                                class="d-none d-sm-block d-flex justify-content-start flex-column text-end">
                                                                <label>จำนวนเงิน</label>
                                                                <div class="info">
                                                                    <strong>{{ priceAll(item.amount) }}</strong>
                                                                </div>
                                                            </div>
                                                            <div
                                                                class="d-block d-sm-none d-flex justify-content-start flex-column text-start">
                                                                <label>จำนวนเงิน</label>
                                                                <div class="info">
                                                                    <strong>{{ priceAll(item.amount) }}</strong>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class=" mb-2 col-6  col-sm-3 col-md-3 col-lg-2">
                                                            <div class="d-flex justify-content-start flex-column">
                                                                <label>สถานะ</label>
                                                                <div class="info">
                                                                    <span :class="getBgColor(item.status)"
                                                                        class="badge"> {{ getTextStatus(item.status)
                                                                        }}</span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </template>
                                    </template>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="push"></div>
        </div>
      </div>
    </div>
</template>
<script>
import { checkTranferService } from '@/services'
import { mapActions } from 'vuex'
import { STATUS_SUCCESS } from '@/constants'
import { get, isEmpty } from '@/utils'
import baac from '@/assets/banks/baac.svg'
import bay from '@/assets/banks/bay.svg'
import bbl from '@/assets/banks/bbl.svg'
import bnp from '@/assets/banks/bnp.svg'
import boa from '@/assets/banks/boa.svg'
import cacib from '@/assets/banks/cacib.svg'
import cimb from '@/assets/banks/cimb.svg'
import citi from '@/assets/banks/citi.svg'
import db from '@/assets/banks/db.svg'
import ghb from '@/assets/banks/ghb.svg'
import gsb from '@/assets/banks/gsb.svg'
import hsbc from '@/assets/banks/hsbc.svg'
import ibank from '@/assets/banks/ibank.svg'
import icbc from '@/assets/banks/icbc.svg'
import jpm from '@/assets/banks/jpm.svg'
import kbank from '@/assets/banks/kbank.svg'
import kkp from '@/assets/banks/kkp.svg'
import ktb from '@/assets/banks/ktb.svg'
import lhb from '@/assets/banks/lhb.svg'
import mb from '@/assets/banks/mb.svg'
import mega from '@/assets/banks/mega.svg'
import mufg from '@/assets/banks/mufg.svg'
import rbs from '@/assets/banks/rbs.svg'
import sc from '@/assets/banks/sc.svg'
import scb from '@/assets/banks/scb.svg'
import smbc from '@/assets/banks/smbc.svg'
// import tcap from '@/assets/banks/tcap.svg'
import tisco from '@/assets/banks/tisco.svg'
import tmb from '@/assets/banks/tmb.svg'
import uob from '@/assets/banks/uob.svg'
import ttb from '@/assets/banks/ttb.svg'
import * as numeral from 'numeral'
export default {
  data () {
    return {
      filters: [
        { id: '1', name: 'ทั้งหมด', active: true },
        { id: '2', name: 'เติม', active: false },
        { id: '3', name: 'ถอน', active: false }
      ],
      activeFilters: 1,
      listTransaction: [],
      imageBankMapping: {
        baac: baac,
        bay: bay,
        bbl: bbl,
        bnp: bnp,
        boa: boa,
        cacib: cacib,
        cimb: cimb,
        citi: citi,
        db: db,
        ghb: ghb,
        gsb: gsb,
        hsbc: hsbc,
        ibank: ibank,
        icbc: icbc,
        jpm: jpm,
        kbank: kbank,
        kkp: kkp,
        ktb: ktb,
        lhb: lhb,
        mb: mb,
        mega: mega,
        mufg: mufg,
        rbs: rbs,
        sc: sc,
        scb: scb,
        smbc: smbc,
        // tcap: tcap,
        tisco: tisco,
        tmb: tmb,
        uob: uob,
        ttb: ttb
      }
    }
  },
  async created () {
    await this.getTranfer('1')
  },
  methods: {
    ...mapActions(['setLoading', 'openInfoPopup']),
    setActiveFilter (index) {
      this.filters.forEach((filter, i) => {
        filter.active = i === index
      })
      this.activeFilters = this.filters[index].id
    },
    getStatus (type) {
      let typeDesc = ''
      switch (Number(type)) {
        case 0:
          typeDesc = 'รอดำเนินการ'
          break
        case 1:
          typeDesc = 'ดำเนินการแล้ว'
          break
        default:
          typeDesc = 'ล้มเหลว'
          break
      }
      return typeDesc
    },
    getTextStatus (type) {
      let typeDesc = ''
      switch (Number(type)) {
        case 0:
          typeDesc = 'รอยอดจากธนาคาร'
          break
        case 1:
          typeDesc = 'อัพเดตเครดิตสำเร็จ'
          break
        default:
          typeDesc = 'ล้มเหลว'
          break
      }
      return typeDesc
    },
    checkData (value) {
      return isEmpty(value)
    },
    async getTranfer (option) {
      this.setLoading(true)
      window.scrollTo(0, 0)
      try {
        const resp = await checkTranferService()
        if (resp.status_code === STATUS_SUCCESS) {
          // console.log(option)
          switch (option) {
            case '2': {
              this.listTransaction = resp.data.filter(e => (e.stagement === 'เติมเงิน' || e.stagement === 'เติมเครดิตตรง'))
              // this.listTransaction = resp.data.stagement === 'เติมเงิน' ? resp.data : []
              // console.log(this.listTransaction)
              break
            }
            case '3':
              this.listTransaction = resp.data.filter(e => (e.stagement === 'ถอนเงิน' || e.stagement === 'ถอนเครดิตตรง'))
              break
            default:
              this.listTransaction = resp.data
              break
          }
        }
      } catch (error) { }
      this.setLoading(false)
    },
    getBg (value) {
      let classDesc = ''
      switch (Number(value)) {
        case 0:
          classDesc = 'border-secondary table-dark'
          break
        case 1:
          classDesc = 'border-success table-success'
          break
        default:
          classDesc = 'border-danger table-danger'
          break
      }
      return classDesc
    },
    getColor (value) {
      let classDesc = ''
      switch (Number(value)) {
        case 0:
          classDesc = 'text-dark'
          break
        case 1:
          classDesc = 'text-success'
          break
        default:
          classDesc = 'text-danger'
          break
      }
      return classDesc
    },
    getBgColor (value) {
      let classDesc = ''
      switch (Number(value)) {
        case 0:
          classDesc = 'bg-warning'
          break
        case 1:
          classDesc = 'bg-success'
          break
        default:
          classDesc = 'bg-danger'
          break
      }
      return classDesc
    },
    getIcon (value) {
      let classDesc = ''
      switch (Number(value)) {
        case 0:
          classDesc = 'fas fa-spinner fa-spin'
          break
        case 1:
          classDesc = 'far fa-check-circle'
          break
        default:
          classDesc = 'fas fa-ban'
          break
      }
      return classDesc
    },
    imglink (short) {
      return get(this.imageBankMapping, [short])
    },
    getStagementTextColor (val) {
      if (val === 'เติมเงิน' || val === 'เติมเครดิตตรง') {
        return 'text-success'
      } else {
        return 'text-danger'
      }
    },
    getStagementIcon (val) {
      if (val === 'เติมเงิน') {
        return 'fas fa-folder-plus'
      } else {
        return 'fas fa-folder-minus'
      }
    },
    getclassStagement (stagement) {
      if (stagement === 'เติมเงิน' || stagement === 'เติมเครดิตตรง') {
        return 'bg-label-info'
      } else if (stagement === 'ถอนเงิน' || stagement === 'ถอนเครดิตตรง') {
        return 'bg-label-success'
      }
    },
    priceAll (val) {
      return numeral(val).format('0,0.00')
    }
  }
}
</script>
<style scoped>
.btn-active {
  background-color: #007bff;
  color: white;
}
</style>
